<template>
  <div class="body">
    <div class="search" :class="{ sticky: status == 20 }">
      <!-- 是否紧急 -->
      <div class="tabs" v-if="status != 70">
        <el-tabs v-model="datas.overdue" type="card" @tab-click="search">
          <!-- 全部 -->
          <el-tab-pane :label="$t('message.all')" name=""></el-tab-pane>
          <!-- 紧急 -->
          <el-tab-pane :label="$t('message.overdue')" name="1"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="operationContainer">
        <!-- 日期-->
        <div class="time">
          <el-date-picker v-model="time" type="datetimerange" range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" :start-placeholder="$t('message.startDate')"
            :end-placeholder="$t('message.dateClosed')">
          </el-date-picker>
        </div>

        <!--   /订单号-->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 客户ID-->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 客戶屬性 -->
        <div class="item">
          <el-select v-model="datas.attribute" clearable filterable placeholder="SVIP">
            <el-option :label="item.label" :value="item.value" v-for="(item) in vipList" :key="item.value">
            </el-option>
          </el-select>
        </div>
        <!--人员范围-->
        <div class="item">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
        </div>
        <div class="item">
          <!--  全体人员-->
          <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="operationContainer">
        <div class="leftContainer">
          <!-- 采购 -->
          <div class="item">
            <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 业务 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 配货员 -->
          <div class="item">
            <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!--  搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!--  重置 -->
            <el-button @click="reset">{{ $t("message.reset") }}</el-button>
            <el-button @click="amountRanking" v-if="status == 30" icon="el-icon-sort">金额排序</el-button>
          </div>
        </div>
        <div class="rightContainer">

          <!-- 下单模板 -->
          <a :href="baseURL + '/excelOrder.excelOrderTpl?rand=' + Math.random()" target="_blank"
            rel="noopener noreferrer" style="margin: 0 15px;">
            <el-button type="primary" v-if="status == 20">
              {{ $t("message.formOrder") }}
            </el-button>
          </a>
          <!-- 提出新订单  -->
          <el-button type="primary" @click="placeANewOrder" v-if="status == 20 && isAuth(154)" class="primary">
            {{ $t("message.placeANewOrder") }}
          </el-button>
          <!-- Excel下单  -->
          <!-- <el-button type="primary" @click="excelOrderDialogVisible = true" v-if="status == 20 && isAuth(154)">
            {{ $t("message.excelOrder") }}
          </el-button> -->
          <!-- 订单合单 -->
          <el-button type="primary" v-if="status <= 22" @click="mergeOrder" class="primary">
            {{ $t("message.combinationOfOrders") }}
          </el-button>
          <!-- 订单调整 -->
          <el-button type="success" @click="showOrderAdjust">
            {{ $t("message.orderAdjust") }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" size="mini" v-if="show"
        :max-height="tableautoheight">
        <el-table-column align="center" label="NO" prop="rowNumber" width="60">
        </el-table-column>
        <!-- 选择 -->
        <el-table-column width="45" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :selectList="selectList" />
              <el-checkbox v-model="checked" @change="allChecked" slot="reference"></el-checkbox>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-popover placement="right" title="合计" width="200" trigger="focus">
              <statistics :selectList="selectList" />
              <el-checkbox v-model="scope.row.checked" @change="handleSelectionChange" slot="reference"></el-checkbox>
            </el-popover>
          </template>
        </el-table-column>
        <!--  订单提交时间-->
        <el-table-column align="center" :label="$t('message.orderSubmissionTime')" prop="created_at"
          :width="status == 20 ? 120 : 76">
        </el-table-column>
        <!-- 翻译完了时间 -->
        <el-table-column align="center" :label="$t('message.translationTime')" width="76"
          v-if="status > 20 && status < 40" prop="order_time_node.datetime_translate">
        </el-table-column>
        <!-- 采购提出时间 -->
        <el-table-column align="center" :label="$t('message.purchaseProposalTime')" width="76" v-if="status > 21"
          prop="order_time_node.datetime_confirm">
        </el-table-column>
        <!-- 业务报价时间 -->
        <el-table-column align="center" :label="$t('message.businessQuotationTime')" width="76" v-if="status > 22"
          prop="order_time_node.datetime_offer">
        </el-table-column>
        <!-- 客户提交付款时间 -->
        <el-table-column align="center" :label="$t('message.customerPaymentTime')" v-if="status > 22" width="76"
          prop="order_time_node.datetime_pay_submit">
          <template slot-scope="scope">
            {{ scope.row.order_time_node != null && scope.row.order_time_node.datetime_pay_submit != null ?
              scope.row.order_time_node.datetime_pay_submit :
              '--' }}
          </template>
        </el-table-column>
        <!--  订单类别-->
        <el-table-column align="center" :label="$t('message.orderType')" width="80">
          <template slot-scope="scope">
            <!-- 国际阿里巴巴订单标识 -->
            <p v-if="scope.row.is_alibaba"><img src="@/assets/icon/alibaba.png" alt="" title="阿里巴巴国际站订单"></p>
            <span :class="{ isOEM: scope.row.type_name == 'OEM' }">
              {{ scope.row.type_name }}
            </span>

          </template>
        </el-table-column>
        <!-- 订单属性 -->
        <el-table-column align="center" :label="$t('message.theOrderAttribute')" width="80">
          <template slot-scope="scope">
            <attributeName :name="scope.row.attribute_name" />
            <el-tag type="primary" effect="dark" size="mini" v-if="scope.row.auto_order">自动下单</el-tag>
          </template>
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')" :width="status == 20 ? 250 : 170">
          <template slot-scope="scope">
            <!-- 供应商订单标识 -->
            <p v-if="scope.row.order_extend">
              <el-tag size="mini" type="primary" class="primary" effect="dark"
                v-if="scope.row.order_extend.is_supplier_order">供应商订单</el-tag>
            </p>
            <p>
              <!-- 分批付款标记 -->
              <span v-if="scope.row.part_pay_status == 1" style="vertical-align: middle;"><img
                  src="@/assets/user/stages.png" alt=""></span>
              <!-- 手机下单标记 -->
              <span v-if="scope.row.from_tool != 1" style="vertical-align: middle;"><img src="@/assets/icon/mobile.png"
                  alt="" style="width: 25px;"></span>
              <router-link :to="'/orderDetail?order_sn=' + scope.row.order_sn" target="_blank">
                {{ scope.row.order_sn }} </router-link>
              <span v-if="scope.row.modify_after_offer == 1" style="color:#b4272d">【改】</span>

            </p>
            <p>
              <router-link
                :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                target="_blank" style="color:#606266 ">
                {{ scope.row.user.realname }}
              </router-link>
              <el-popover placement="top-start" trigger="hover" v-if="scope.row.children_user != null" title="子账号信息">
                <p>{{ $t('message.names') }}:{{ scope.row.children_user.children_username }}</p>
                <p>ID:{{ scope.row.children_user.id }}</p>
                <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
              </el-popover>
              <img src="@/assets/icon/illegal.png" alt="" slot="reference" style="vertical-align: middle; width: 30px;"
                v-if="scope.row.user.user_tag != false">
            </p>

          </template>
        </el-table-column>
        <!--  原订单-->
        <el-table-column align="center" :label="$t('message.originalOrder')" :width="status == 20 ? 250 : 160">
          <template slot-scope="scope" v-if="scope.row.relation_order_sn">
            <p>
              <router-link :to="'/orderDetail?order_sn=' + scope.row.relation_order_sn" target="_blank">
                {{ scope.row.relation_order_sn }}</router-link>
            </p>
            <p>{{ scope.row.user.realname }}
            </p>
          </template>
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operator')" width="100">
          <template slot-scope="scope">
            <div class="text-left">
              <!-- 业务员 -->
              <p>
                {{ $t("message.salesman") }}：{{ scope.row.y_admin ? scope.row.y_admin.realname : '' }}
              </p>
              <!-- 配货员 -->
              <p>
                {{ $t("message.distributionMember") }}：{{ scope.row.p_admin ? scope.row.p_admin.realname : '' }}
              </p>
              <!-- 采购员 -->
              <p>{{ $t("message.buyer") }}：{{ scope.row.g_admin ? scope.row.g_admin.realname : '' }}</p>
            </div>
          </template>
        </el-table-column>
        <!--  订单番数-->
        <el-table-column align="center" :label="$t('message.ordersNumber')" width="80" prop="order_detail_count">
        </el-table-column>
        <!--  订单金额.元-->
        <el-table-column align="center" :label="$t('message.amountOfOrderYuan')" width="80"
          prop="total_amount_detail.total_amount">
        </el-table-column>
        <!--  报价状态-->
        <el-table-column align="center" :label="$t('message.quotationStatus')" width="100" v-if="status < 30">
          <template slot-scope="scope">
            <p>
              <span> {{ scope.row.status_name }}</span>
            </p>
            <p v-if="scope.row.order_extend">
              <el-tag size="mini" :type="scope.row.supplier_quote_status ? 'success' : 'primary'" effect="dark"
                v-if="scope.row.order_extend.is_supplier_order && scope.row.supplier_quote_status_text">
                {{ scope.row.supplier_quote_status_text }}
              </el-tag>

            </p>
          </template>
        </el-table-column>
        <!--  业务临时备忘录--->
        <el-table-column align="center" :label="$t('message.businessTemporaryRemarks')" prop="y_remark">
          <template slot-scope="scope">
            <!-- 默认显示可选中的文本，双击变为编辑框 -->
            <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.y_remark">
              <div class="remark-text" slot="reference">
                <div v-if="!scope.row.is_y_remark_edit" @dblclick="y_remark_edit(scope.row)" class="mask">
                </div>
                <el-input type="textarea" v-model="scope.row.y_remark"
                  @blur="editRemark(scope.row.order_sn, scope.row.y_remark, remarkData.remark_type)"
                  class="remark-input" ref="remarkInput"></el-input>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!--  采购订单备注-->
        <el-table-column align="center" :label="$t('message.purchaseOrderRemarks')" v-if="status > 20" prop="g_remark">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.g_remark" :disabled="remarkData.remark_type != 2"
              @blur="editRemark(scope.row.order_sn, scope.row.g_remark, remarkData.remark_type)"></el-input>
          </template>
        </el-table-column>
        <!--  进备注栏-->
        <el-table-column align="center" :label="$t('message.businessFollowUpNotes')" v-if="status == 70">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.follow_remark" :disabled="remarkData.remark_type != 1"
              @blur="followRemarkEdit(scope.row.order_sn, scope.row.follow_remark)"></el-input>
          </template>
        </el-table-column>
        <!--  下载-->
        <el-table-column align="center" :label="$t('message.orderDownload')">
          <template slot-scope="scope">
            <a :href="baseURL + '/client.orderDetailDownload?order_sn=' + scope.row.order_sn">
              <i class="el-icon-sold-out" style="font-size: 25px;"></i></a>
          </template>
        </el-table-column>
        <!--  操作-->
        <el-table-column align="center" :label="$t('message.operation')" width="110">
          <template slot-scope="scope">
            <!--    删除-->
            <p style="margin-bottom: 10px">
              <el-button size="mini" type="success" v-if="isAuth(179)" class="dark"
                @click="deleteOrder(scope.row.order_sn)">
                {{ $t("message.delete") }}
              </el-button>
            </p>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[100, 50, 20, 10]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>


    <!-- 新订单新增 -->
    <addGoods ref="addGoods" />
    <!-- 订单调整 -->
    <orderAdjust ref="orderAdjust" />
    <!-- 删除订单 -->
    <deleteOrder ref="deleteOrder" />
  </div>
</template>
<script>
import addGoods from '@/views/orderDetail/components/addGoods'
import excelOrder from './excelOrder'
import { vipList } from '@/utlis/options'
import statistics from './statistics'
import orderAdjust from '../components/orderAdjust'
import deleteOrder from '../components/deleteOrder'
export default {
  components: {
    addGoods,
    excelOrder,
    statistics,
    orderAdjust,
    deleteOrder
  },
  props: ["status"],
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 200 : 800,
      vipList,
      user_id: '',
      dialogVisible: false,
      addGoodsDialogVisible: false,
      excelOrderDialogVisible: false,
      datas: {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 100,
        overdue: '',
      },
      time: [],
      orderPaymentList: [],
      orderStatusList: [],
      adminOrganization: [],
      total: 0,
      tableData: [],
      selectList: [],
      show: false,
      remarkDialogVisible: false, //订单备注
      remarkTitle: "", //备注标题
      remarkData: {
        order_sn: "",
        remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
        remark: "",
      },
      //   类型
      typeDialogVisible: false,
      typeData: {
        order_sn: [],
        type: "",
      },
      userList: [],
      isSort: false,//排序

      checked: false,//选择
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    typeList() {
      return this.$store.state.typeList;
    },
  },
  created() {
    if (this.$route.query.overdue) {
      this.datas.overdue = '1'
    }
    this.orderList();
    this.$api.roleApi.getAdminOrganization().then((res) => {
      this.adminOrganization = res.data;

    });

  },
  methods: {
    orderList() {
      this.show = false;
      this.datas.status = this.status;
      this.selectList = []
      if (this.time.length > 0) {
        this.datas.created_at_start = this.time[0]
        this.datas.created_at_end = this.time[1]
      } else {
        this.datas.created_at_start = ''
        this.datas.created_at_end = ''
      }
      this.$api.orderApi.orderList(this.datas).then((res) => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.orderList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 10,
        y_id: '',
        p_id: '',
        g_id: '',
        attribute: '',
      };
      this.$refs.cascader.orgId = [];
      this.orderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    //全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
      this.handleSelectionChange()
    },
    handleSelectionChange() {
      this.selectList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.selectList.push(item)
        }
      })
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },


    // 实时编辑备注
    editRemark(order_sn, remark, remark_type,) {
      let datas = {
        order_sn,
        remark,
        remark_type,
      }
      this.$api.orderApi.updateRemark(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);
      });
      // 编辑完成后重置编辑状态
      const row = this.tableData.find(item => item.order_sn === order_sn);
      if (row) {
        this.$set(row, 'is_y_remark_edit', false);
      }
    },
    // 双击进入编辑状态
    y_remark_edit(row) {
      if (this.remarkData.remark_type != 1) return
      this.$set(row, 'is_y_remark_edit', true)
    },

    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    //合单
    mergeOrder() {
      if (this.selectList == false) return this.$message.error(this.$t('message.selectableOperational'))
      let datas = {
        orderSnSet: []
      }
      this.selectList.forEach(item => {
        datas.orderSnSet.push(item.order_sn)
      })
      this.$confirm('此操作将多个订单合并成一个订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.orderApi.mergeOrder(datas).then(res => {
          this.orderList();
          this.selectList = []
          this.$alert("合单号的单号:" + res.data, "提示", {
            confirmButtonText: "确定",
            center: true,
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //新增商品
    placeANewOrder() {
      this.$refs.addGoods.dialogVisible = true
      this.$refs.addGoods.setData(
        '',
        '',
      )
      this.$refs.addGoods.goods = []

    },
    //金额排序
    amountRanking() {
      this.isSort = !this.isSort
      this.tableData = this.tableData.sort((a, b) => {
        if (this.isSort) {
          return b.total_amount_detail.total_amount - a.total_amount_detail.total_amount
        } else {
          return a.total_amount_detail.total_amount - b.total_amount_detail.total_amount
        }

      })
    },
    // 显示订单调整
    showOrderAdjust() {
      if (this.selectList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.$refs.orderAdjust.allotVal = {
        order_sn_set: [],
        y_id: this.selectList.length == 1 ? this.selectList[0].y_id : "",
        g_id: this.selectList.length == 1 ? this.selectList[0].g_id : "",
        p_id: this.selectList.length == 1 ? this.selectList[0].p_id : "",
      };

      this.selectList.forEach((item) => {
        this.$refs.orderAdjust.allotVal.order_sn_set.push(item.order_sn);
        this.$refs.orderAdjust.typeData.order_sn.push(item.order_sn);
      });
      this.$refs.orderAdjust.dialogVisible = true;
    },

    //修改跟进备注
    followRemarkEdit(order_sn, follow_remark) {
      let datas = {
        order_sn,
        follow_remark
      }
      this.$api.orderApi.followRemarkEdit(datas)
    },
    // 删除订单
    deleteOrder(order_sn) {
      this.$refs.deleteOrder.deleteData = {
        order_sn_set: [order_sn],
        delete_reason: "",
      }
      this.$refs.deleteOrder.dialogVisible = true
    },
    // 刷新订单列表
    refresh() {
      this.selectList = []
      this.orderList();
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  position: relative;
}

.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  background-color: #F8F8F8;
}

.search {


  /deep/.el-select {
    width: 200px;
  }

  /deep/.el-input__inner {
    width: 200px;
  }
}

.table {
  margin: 20px 0;

  /deep/.el-textarea__inner {
    min-height: 100px !important;
    padding: 3px !important;
  }

  /deep/.is-disabled {
    .el-textarea__inner {
      background-color: #fff;
      color: #606266;
    }

  }

  /deep/.el-checkbox {
    line-height: 40px;
    min-height: 40px;
    min-width: 40px;
  }
}

.item {
  margin-right: 20px;

}

.operationContainer {
  display: flex;
  margin: 0;
  padding: 10px 0;

  .time {
    width: 420px;
    margin-right: 20px;

    .el-date-editor {
      width: 100%;
    }
  }
}

/deep/.cell {
  padding: 0 3px !important;
}



a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}



.isOEM {
  color: #113e74;
  font-size: 18px;
  font-weight: bold;
}



.remark-text {
  position: relative;

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    z-index: 999;
  }
}

.remark-input {
  width: 100%;
  min-height: 60px;
}
</style>